import { useTranslation } from 'react-i18next'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

const MapFooter = () => {
    const { t } = useTranslation()

    return (
        <StyledContainer>
            <div>
                <StyledTypography>
                    {t('LABEL.MAP.FOOTER.COPYRIGHT', {
                        version: process.env.REACT_APP_WEB_VERSION || '2.0.0',
                    })}
                </StyledTypography>
            </div>
        </StyledContainer>
    )
}

export default MapFooter

const StyledContainer = styled('div')(({ theme }) => ({
    height: '22px',
    marginTop: '-22px',
    padding: '0 32px',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
    backgroundColor: '#1C52A3E5 !important',
    [theme.breakpoints.down('sm')]: {
        padding: 0,
        paddingRight: '5px',
    },
}))

const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: '11px',
    marginRight: '10px',
    [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
    },
}))
